export const CloudConnectedIcon = ({ connected, ...props }) => (
    <span {...props}>
        <i className={"fa-cloud fa-solid " + (connected ? "text-success" : "")}></i>
        <span className="sr-only">{connected ? "Online" : "Offline"}</span>
    </span>
)
